import { NatFormDetailObject } from "@natiwi/core/forms/form-detail-object";
import { FormGroup, FormControl, Validators, FormBuilder } from "@angular/forms";

export abstract class NatFormDetailCatalog extends NatFormDetailObject {

    constructor(formBuilder: FormBuilder) {
        super(formBuilder);
    }
}